import SectionHeading from '../../../components/SectionHeading'
import Timeline from './Timeline'

const SecOurRoadmap = ({data}) => {

  return (
    <section className="roadmap" style={{paddingBottom:0}} id="roadmap">
        <SectionHeading
            title='Our Roadmap'
            text='The roadmap for Green Earth Metaverse lays down the path for the development of the project. It is a guide for the team to follow and for the community to understand the project’s progress.'
        />
        <div className="container">
          <div className="row">
            <div className="timeline-split">
              <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="timeline section-box-margin">
                      {data && data.map((item , key) => (
                          <Timeline
                            key={key}
                            timelineClass={item.timelineClass}
                            title={item.title}
                            date_from={item.date_from}
                            date_to={item.date_to}
                            description={item.description}
                          />
                        ))}
                      <div className="circle"></div>
                  </div>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
}

export default SecOurRoadmap;